
const storefrontAccessToken = '10f8be35de51ef9bbd2aca0b488dc0af';
const shopDomain = 'jumpichiban.com';
const collectionHandle = 'figures-test';

async function fetchAllProductsInCollection() {
  let hasNextPage = true;
  let endCursor = null;
  const characters = new Set();

  while (hasNextPage) {
    const query = `
      query {
        collection(handle: "${collectionHandle}") {
          products(first: 100${endCursor ? `, after: "${endCursor}"` : ''}) {
            edges {
              node {
                title
                metafields(identifiers: [{namespace: "custom", key: "character"}]) {
                  namespace
                  key
                  value
                }
              }
              cursor
            }
            pageInfo {
              hasNextPage
            }
          }
        }
      }
    `;

    const response = await fetch(`https://${shopDomain}/api/2023-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': storefrontAccessToken
      },
      body: JSON.stringify({ query })
    });

    const json = await response.json();
    //console.log(JSON.stringify(json, null, 2));
    const edges = json?.data?.collection?.products?.edges || [];

    edges.forEach(({ node }) => {
      const metafield = node.metafields?.[0];
      if (metafield && metafield.value) {
        try {
          const parsed = JSON.parse(metafield.value);

          if (Array.isArray(parsed)) {
            parsed.forEach(val => {
              const cleaned = val.trim();
              if (cleaned) characters.add(cleaned);
            });
          } else {
            const cleaned = metafield.value.trim();
            if (cleaned) characters.add(cleaned);
          }
        } catch (e) {
          // Si ce n’est pas un JSON (ancienne valeur ?), on traite comme une string simple
          const cleaned = metafield.value.trim();
          if (cleaned) characters.add(cleaned);
        }
      }
    });

    hasNextPage = json?.data?.collection?.products?.pageInfo?.hasNextPage;
    if (hasNextPage) {
      endCursor = edges[edges.length - 1].cursor;
    }
  }
  console.log(characters);
  return Array.from(characters).sort((a, b) => a.localeCompare(b));
}
function renderAlphabetFilter(sortedList) {
  const container = document.querySelector('.alphabet_filter');
  if (!container) return;
 return;
  const filterName = 'gf_739948';
  const title = document.createElement('h2');
  title.textContent = 'All Characters';
  container.innerHTML = ''; // reset previous content
  container.appendChild(title);

  let currentLetter = '';
  let currentUl;

  sortedList.forEach((value, index) => {
    let firstLetter = value.slice(0, 1).toUpperCase();
    if (firstLetter >= '0' && firstLetter <= '9') {
      firstLetter = '0-9';
    }

    if (firstLetter !== currentLetter) {
      if (currentUl) {
        container.appendChild(currentUl); // ferme la liste précédente
      }

      const h3 = document.createElement('h3');
      h3.classList.add('letter-separator');
      h3.textContent = firstLetter;
      container.appendChild(h3);

      currentUl = document.createElement('ul');
      currentUl.classList.add('filter-column');
      currentLetter = firstLetter;
    }

    const li = document.createElement('li');
    const a = document.createElement('a');
    const encodedValue = encodeURIComponent(value);
    a.href = `${window.location.pathname}?${filterName}=${encodedValue}`;
    a.textContent = value;
    li.appendChild(a);
    currentUl.appendChild(li);

    // Append last list if end of loop
    if (index === sortedList.length - 1 && currentUl) {
      container.appendChild(currentUl);
    }
  });
}

fetchAllProductsInCollection().then((sortedList) => {
  //localStorage.setItem('characters_list', JSON.stringify(sortedList));
  renderAlphabetFilter(sortedList); // 👈 Ici !
});


